export default "__VITE_ASSET__mENrwXNd__"